import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useEntitlements } from "../../entitlements/EntitlementContext";

export default function MSICustomerNav({ mobile = false }) {
  const { pathname } = useLocation();
  const { isAdmin } = useEntitlements();
  return (
    <nav className={`msi-customer-nav ${mobile ? "msi-mobile-nav" : "msi-desktop-nav"}`} aria-label={mobile ? "MSI mobile navigation" : "MSI customer navigation"}>
      <Link className={pathname === "/msi" ? "active" : ""} to="/msi"><span aria-hidden="true">⌂</span>Today</Link>
      <Link to="/msi#structures"><span aria-hidden="true">≡</span>Structures</Link>
      <Link to="/msi#data-status"><span aria-hidden="true">•••</span>More</Link>
      {isAdmin && <Link className="msi-operator-link" to="/msi/operator"><span aria-hidden="true">◇</span>Operator</Link>}
    </nav>
  );
}
